import { MenuProps } from 'antd';
import { EyeOutlined, CheckSquareOutlined, StopOutlined, EditOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';
import TextTypography from '../Typography/Text';
import BillIcon from 'src/assets/icons/billIcon';
import RejectIcon from 'src/assets/icons/rejectIcon';

interface ActionItemParams {
    item: any;
    optionalActions?: ('view' | 'approved' | 'rejected' | 'hold' | 'edit' | 'credit' | 'plan' | 'reasignCredit')[];
    setHoldModal?: (id: string) => void;
    setModalType?: (type: 'hold' | 'accept' | 'reject') => void;
    setLeadModalVisible?: (visible: boolean) => void;
    setEditingLeadId?: (id: string) => void;
    isUpdateLoading?: boolean;
    AssigneLeadToCreditHandler?: (params: { id: string }) => void;
    MoveLeadFromHoldHandler?: (params: { id: string }) => void;

    setIsPlanModalVisible?: (id: string) => void;
}

export const getActionItems = ({
    item,
    optionalActions,
    setHoldModal,
    setModalType,
    setLeadModalVisible,
    setEditingLeadId,
    isUpdateLoading,
    AssigneLeadToCreditHandler,
    MoveLeadFromHoldHandler,
    setIsPlanModalVisible,
}: ActionItemParams): MenuProps['items'] => {
    const items: MenuProps['items'] = [];

    if (optionalActions?.includes('edit')) {
        items.push({
            label: (
                <div
                    onClick={() => {
                        if (setLeadModalVisible && setEditingLeadId) {
                            setLeadModalVisible(true);
                            setEditingLeadId(item.id);
                        }
                    }}
                    className="flex items-center gap-[16px]"
                >
                    <EditOutlined className="w-[20px] h-[20px] pt-2" />
                    <TextTypography fontSize={14}>Edit Lead</TextTypography>
                </div>
            ),
            key: 'edit',
        });
    }

    if (optionalActions?.includes('view')) {
        items.push({
            label: (
                <div className="flex items-center gap-2">
                    <EyeOutlined className="w-[20px] h-[20px] pt-2" />
                    <Link to={`/lead-detail/${item.id}`}>
                        <TextTypography fontSize={14}>View Lead Details</TextTypography>
                    </Link>
                </div>
            ),
            key: 'view',
        });
    }

    if (optionalActions?.includes('credit')) {
        items.push({
            label: (
                <div
                    onClick={() => {
                        if (!item.is_draft && AssigneLeadToCreditHandler && !isUpdateLoading) {
                            AssigneLeadToCreditHandler({ id: item.id });
                        }
                    }}
                    className={`flex items-center gap-2 ${item.is_draft ? 'hidden' : ''}`}
                >
                    <ArrowUpOutlined className="w-[20px] h-[20px] pt-2" />
                    <TextTypography fontSize={14}>{isUpdateLoading ? <Spin size="small" /> : 'Ask For Credit Approval'}</TextTypography>
                </div>
            ),
            key: 'credit',
        });
    }
    if (optionalActions?.includes('reasignCredit')) {
        items.push({
            label: (
                <div
                    onClick={() => {
                        if (!item.is_draft && MoveLeadFromHoldHandler && !isUpdateLoading) {
                            MoveLeadFromHoldHandler({ id: item.id });
                        }
                    }}
                    className={`flex items-center gap-2 ${item.is_draft ? 'hidden' : ''}`}
                >
                    <ArrowUpOutlined className="w-[20px] h-[20px] pt-2" />
                    <TextTypography fontSize={14}>{isUpdateLoading ? <Spin size="small" /> : 'Ask For Credit Approval'}</TextTypography>
                </div>
            ),
            key: 'reasignCredit',
        });
    }

    if (optionalActions?.includes('plan')) {
        items.push({
            label: (
                <div
                    onClick={() => {
                        if (setIsPlanModalVisible) {
                            setIsPlanModalVisible(item.id);
                        }
                    }}
                    className="flex items-center gap-2"
                >
                    <BillIcon />
                    <TextTypography fontSize={14}>View Plan Details</TextTypography>
                </div>
            ),
            key: 'plan',
        });
    }

    if (optionalActions?.includes('approved')) {
        items.push({
            label: (
                <div
                    onClick={() => {
                        if (setHoldModal && setModalType) {
                            setHoldModal(item.id);
                            setModalType('accept');
                        }
                    }}
                    className="flex items-center gap-2"
                >
                    <CheckSquareOutlined className="w-[20px] h-[20px] pt-2" />
                    <TextTypography fontSize={14}>Approved</TextTypography>
                </div>
            ),
            key: 'approved',
        });
    }

    if (optionalActions?.includes('rejected')) {
        items.push({
            label: (
                <div
                    onClick={() => {
                        if (setHoldModal && setModalType) {
                            setHoldModal(item.id);
                            setModalType('reject');
                        }
                    }}
                    className="flex items-center gap-2"
                >
                    <RejectIcon />
                    <TextTypography fontSize={14}>Rejected</TextTypography>
                </div>
            ),
            key: 'rejected',
        });
    }

    if (optionalActions?.includes('hold')) {
        items.push({
            label: (
                <div
                    onClick={() => {
                        if (setHoldModal && setModalType) {
                            setHoldModal(item.id);
                            setModalType('hold');
                        }
                    }}
                    className="flex items-center gap-2"
                >
                    <StopOutlined className="w-[20px] h-[20px] pt-2" />
                    <TextTypography fontSize={14}>Move to Hold</TextTypography>
                </div>
            ),
            key: 'hold',
        });
    }

    return items;
};
